import React from "react";
import { CircularProgress } from "@material-ui/core";

export default function CustomLoader(){
    return(
        <div style={{ textAlign: "center" }}>
        <p>Loading...</p>
        <br></br>
        <CircularProgress color="primary" />
      </div>
    )
}